import React from "react";
import { Typography, Box } from "@material-ui/core";

type Props = {
  caption: string;
  text?: string | null;
};

export const CaptionedText: React.FC<Props> = ({ caption, text }) => (
  <Box display="flex" flexDirection="column">
    <Typography component="span" variant="caption" color="textSecondary">
      {caption}
    </Typography>
    {text != null && (
      <Typography component="span" variant="subtitle1" color="textPrimary">
        {text}
      </Typography>
    )}
  </Box>
);
